import * as tslib_1 from "tslib";
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Button, Input, Pagination, Icon, Checkbox, Tooltip, Modal } from "@h3/antd-vue";
import WorkItemMixin from "./mixins/workitem";
import CommonDrawer from "./components/modals/drawer.vue";
import { workflowCenterApi, } from "../../../../api";
import common from "../../../../common/pc";
import CommonTable from "./components/common-table/table.vue";
let myComments = class myComments extends mixins(WorkItemMixin) {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.currentComment = '';
        this.currentEdit = '';
        this.tableData = [];
        this.mode = "standalone";
        this.isSelectAll = false;
        this.defaultTableColumns = [
            {
                dataIndex: "orderNumber",
                width: 24,
                align: "left",
                hSlot: "indexTitle",
                bSlot: "orderNumber"
            },
            {
                dataIndex: "content",
                width: 400,
                hSlot: "contentTitle",
                bSlot: "contentName"
            },
            {
                dataIndex: "operation",
                width: 60,
                hSlot: "operationTitle",
                bSlot: "operationName"
            }
        ];
        this.checkedItems = [];
        this.indeterminate = false;
    }
    closeModal() {
        this.visible = false;
    }
    modalOK() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.currentComment === '') {
                this.$message.error('审批意见不能为空！');
                return;
            }
            let params = {
                content: this.currentComment,
                sortKey: 0
            };
            if (this.currentEdit) {
                params.id = this.currentEdit.id;
                params.sortKey = this.currentEdit.sortKey;
            }
            else {
                if (this.tableData.length === 10) {
                    this.$message.error('最多设置10条常用审批意见！');
                    return;
                }
            }
            let res = yield workflowCenterApi.saveCommonComment(params);
            if (res.errcode === 0) {
                this.getList();
                this.visible = false;
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    editComments(record) {
        this.currentComment = record.content;
        this.currentEdit = record;
        this.visible = true;
    }
    delComments(record) {
        let _this = this;
        this.$confirm({
            title: '确定要删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                this.deleteCommonComment(record.id);
            }
        });
    }
    deleteCommonComment(ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workflowCenterApi.deleteCommonComment({
                ids: ids
            });
            const vm = this;
            if (res.errcode === 0) {
                vm.$message.success('删除成功');
                this.getList();
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    batchDel() {
        let _this = this;
        this.$confirm({
            title: '确定要删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                let ids = _this.checkedItems.map(el => el.id);
                this.deleteCommonComment(ids.join(';'));
            }
        });
    }
    sortEnd(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let resParams = [];
            data.forEach((el, index) => {
                resParams.push({
                    id: el.id,
                    sortKey: index
                });
            });
            let res = yield workflowCenterApi.updateCommonComment({
                list: resParams
            });
            if (res.errcode === 0) {
                this.getList();
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    onVisibleChange(val) {
        if (!val) {
            this.currentEdit = '';
            this.currentComment = '';
        }
    }
    commentChange() {
        if (this.currentComment.length > 450) {
            this.currentComment = this.currentComment.substr(0, 450);
        }
    }
    getList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workflowCenterApi.getCommonCommentList({});
            if (res.errcode === 0) {
                res.data.forEach((e, index) => {
                    e.orderNumber = index + 1;
                });
                this.tableData = res.data;
            }
            else {
                this.$message.error(res.errmsg);
            }
            //判断当前常用审批意见是否超过十条（历史数据）如果超过删除多余部分
            if (res.data.length > 10) {
                for (let i = 10; i < res.data.length; i++) {
                    this.deleteCommonComment(res.data[i].id);
                }
            }
        });
    }
    created() {
        this.getList();
        // for (let index = 0; index < 50; index++) {
        //   this.currentComment = index + ''
        //   this.modalOK()
        // }
    }
    get scrollYHeight() {
        if (this.scrollHeight) {
            return this.scrollHeight;
        }
        return this.scrollY;
    }
    get columns() {
        if (this.tableColumns) {
            return this.tableColumns;
        }
        return this.defaultTableColumns;
    }
    get rootAdmin() {
        return this.$store && this.$store.state.System.System.isRootAdmin;
    }
    /*
     * 当checkbox选择change时事件
     * 半选全选
     */
    onItemCheckboxChange() {
        const isCheckedItems = this.tableData.filter((d) => d.checked);
        this.checkedItems = isCheckedItems;
        this.indeterminate = !!this.checkedItems.length && this.checkedItems.length < this.tableData.length;
        if (!isCheckedItems.length) {
            this.isSelectAll = false;
            this.indeterminate = false;
        }
        else if (isCheckedItems.length < this.tableData.length) {
            this.isSelectAll = false;
            this.indeterminate = true;
        }
        else {
            this.isSelectAll = true;
            this.indeterminate = false;
        }
    }
    /**
     * 全选
     */
    selectAll(e) {
        const isChecked = e.target.checked;
        if (isChecked) {
            this.tableData.forEach((item) => {
                item.checked = true;
            });
            this.checkedItems = this.tableData;
        }
        else {
            this.tableData.forEach((item) => {
                item.checked = false;
            });
            this.checkedItems = [];
        }
    }
    onLanguageChange() {
        this.setLoadAllTxt();
    }
};
tslib_1.__decorate([
    Prop({
        default: true
    })
], myComments.prototype, "showTitle", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], myComments.prototype, "originate", void 0);
tslib_1.__decorate([
    Prop()
], myComments.prototype, "scrollHeight", void 0);
tslib_1.__decorate([
    Prop()
], myComments.prototype, "appCode", void 0);
tslib_1.__decorate([
    Prop()
], myComments.prototype, "tableColumns", void 0);
tslib_1.__decorate([
    Watch('visible')
], myComments.prototype, "onVisibleChange", null);
tslib_1.__decorate([
    Watch("$i18n.locale")
], myComments.prototype, "onLanguageChange", null);
myComments = tslib_1.__decorate([
    Component({
        name: "myComments",
        components: {
            // filterCard: filterCard,
            // QueryWorkitem,
            AButton: Button,
            AInputSearch: Input.Search,
            ACheckbox: Checkbox,
            AInput: Input,
            APagination: Pagination,
            ATooltip: Tooltip,
            AIcon: Icon,
            CommonDrawer,
            // BatchFailList,
            // BatchSuccessInfo,
            PageLoading: common.components.PageLoading,
            PageNoData: common.components.PageNoData,
            PageLoadFail: common.components.LoadFail,
            CommonTable,
            AModal: Modal
        }
    })
], myComments);
export default myComments;
